import { render, staticRenderFns } from "./EduJain.vue?vue&type=template&id=09752363&scoped=true&"
import script from "./EduJain.vue?vue&type=script&lang=js&"
export * from "./EduJain.vue?vue&type=script&lang=js&"
import style0 from "./EduJain.vue?vue&type=style&index=0&id=09752363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09752363",
  null
  
)

export default component.exports